<template>
    <div class="category-slider-show">
        <div class="category-banner">
            <div class="category-banner-inner" v-if="image_path.length > 0 && image_loaded">
                <img :src="image_path" @error="setDefaultHeight()" />
            </div>
            <div class="category-banner-inner min-height-with-banner" v-else>

            </div>
        </div>
        <div class="banner-area">
            <div class="container">
                <div class="row">
                    <div class="col-6 col-lg-10 col-md-8 col-sm-8">
                        <div class="row pl-3 pl-sm-0 pr-3 pr-sm-0">
                            <h1 class="d-block w-100">
                                <span>{{ searchAndSetBannerText() }}</span>
                            </h1>
                            <!-- <form
                                class="form-inline pt-4 flex-column align-items-start"
                                @submit.prevent="onSubmitLicencePlateSearch('searchForm')"
                            >
                                <div class="trucktyre-block mb-4">
                                    <h2
                                        class="color-white font-20 mb-3 text-shadow"
                                    >{{ $t('Tyres you are looking for') }}?</h2>

                                    <b-form-select
                                        v-model="licencePlateSearch.vehicleType"
                                        id="carType"
                                        name="carType"
                                        @change="changeVehicleType($event)"
                                        class="custom-select vehicle-selection"
                                        value-field="car_type"
                                        text-field="car_type"
                                    >
                                        <template v-slot:first>
                                            <b-form-select-option
                                                :value="null"
                                                disabled
                                            >{{ $t('Vehicle Type') }}</b-form-select-option>
                                        </template>
                                        <b-form-select-option
                                            v-for="vehicleType in vehicleTypes"
                                            :value="vehicleType.car_type"
                                            :key="vehicleType.car_type"
                                        >
                                            <span
                                                v-if="vehicleType.car_type == 'Car'"
                                            >{{ $t('Car/SUV/4X4') }}</span>
                                            <span
                                                v-else-if="vehicleType.car_type == 'Light Truck'"
                                            >{{ $t('Light Commercial Vehicle') }}</span>
                                        </b-form-select-option>
                                    </b-form-select>
                                </div>
                                <div class="cartyre-block">
                                    <div class="form-group mr-sm-3 mb-2">
                                        <b-form-input
                                            type="text"
                                            class="form-control licence-plate"
                                            placeholder="Licence Plate"
                                            v-model.trim="licencePlateSearch.licencePlate"
                                        ></b-form-input>
                                    </div>
                                    <button
                                        type="button"
                                        @click="searchByLicencePlate()"
                                        :disabled="licencePlateSearch.licencePlate == ''"
                                        class="btn licence-button bg-yellow mb-2"
                                    >Search</button>
                                </div>
                            </form> -->
                        </div>
                    </div>
                </div>
            </div>
            <div class="search-tyre">
                <div class="container margin-top-66">
                    <b-card no-body class="bg-transparent border-0">
                        <b-tabs card class="bg-transparent px-lg-5 px-md-1" :content-class='{"search-tyre-by-dealer" : ("Service Points" == selectedSearchedTab)}'>
                            <b-tab class="bg-transparent" @click="changeVehicleType('Car')" :active="'Car' == activeVehicleTypes">
                              <template #title>
                                <div class="tab-icon car-icon"></div>
                                <p class="m-0 font-weight-bold text-center">
                                  {{ $t('Car') }}
                                </p>
                              </template>
                                <b-card-text>
                                    <div class="cs-search-home">
                                        
                                        <div class="srch-form">
                                            <form class="form-inline">
                                                <div class="srch-title">
                                                    <p>{{ $t('Search by tyre size') }} :</p>
                                                </div>
                                                <div class="">
                                                    <b-modal id="modal-1"    hide-footer hide-header >
                                                            <b-button class="closeicon" @click="$bvModal.hide('modal-1')"><i class="fas fa-times"></i></b-button>
                                                        <img v-show="currentLang == 'en_GB'" src="../../public/images/Renkaatalle-rengasvalinta_english.png" />
                                                        <img v-show="currentLang == 'fi_FI'" src="../../public/images/Renkaatalle-rengasvalinta_finnish.png" />
                                                    </b-modal>
                                                </div>
                                                <div class="form-items">
                                                    <label>{{ $t('Width') }}</label>
                                                    <b-form-select 
                                                        v-model="searchBySize.width"
                                                        id="widths" 
                                                        name="widths"
                                                        :value="carSelectedWidth"
                                                        @change="changeWidth($event)"
                                                        class="custom-select"
                                                        :options="widths"
                                                        value-field="width"
                                                        text-field="width">
                                                        <!-- <option selected>{{ $t('Width') }}</option> -->
                                                            <!-- <template v-slot:first>
                                                                <b-form-select-option :value="null" disabled>255</b-form-select-option>
                                                            </template> -->
                                                    </b-form-select>
                                                </div>
                                                <div class="form-items">
                                                    <label>{{ $t('Height') }}</label>
                                                    <b-form-select 
                                                        v-model="searchBySize.height"
                                                        id="height" 
                                                        name="height" 
                                                        @change="changeHeight($event)"
                                                        class="custom-select"
                                                        :options="heights"
                                                        value-field="aspect_ratio" 
                                                        text-field="aspect_ratio">
                                                            <!-- <template v-slot:first>
                                                                <b-form-select-option :value="null" disabled>55</b-form-select-option>
                                                            </template> -->
                                                    </b-form-select>
                                                </div>
                                                <div class="form-items">
                                                    <label>{{ $t('Wheel Diameter') }}</label>
                                                    <b-form-select 
                                                        v-model="searchBySize.diameter"
                                                        id="diameter" 
                                                        name="diameter" 
                                                        @change="changeDiameter($event)"
                                                        class="custom-select"
                                                        :options="diameters"
                                                        value-field="diameter"
                                                        text-field="diameter">
                                                            <!-- <template v-slot:first>
                                                                <b-form-select-option :value="null" disabled>16</b-form-select-option>
                                                            </template> -->
                                                    </b-form-select>
                                                </div>
                                                <div class="form-items">
                                                    <label>{{ $t('Season') }}</label>
                                                    <b-form-select 
                                                        v-model="searchBySize.tyreSeason"
                                                        id="tyreSeason" 
                                                        name="tyreSeason" 
                                                        @change="changeTyreSeason($event)"
                                                        class="custom-select"
                                                        value-field="name" 
                                                        text-field="name">
                                                            <!-- <template v-slot:first>
                                                                <b-form-select-option :value="null">{{ $t('All Seasons') }}</b-form-select-option>
                                                            </template> -->

                                                            <b-form-select-option  
                                                                v-for="allTyreSeason in allTyreSeasons" 
                                                                :value="allTyreSeason.name" 
                                                                :key="allTyreSeason.name" 
                                                                >{{ $t(allTyreSeason.name) }}</b-form-select-option>
                                                    </b-form-select>
                                                </div>
                                                <button type="button"  @click="searchByTyreSize()" class="btn search-button"> {{ $t('Search') }}<i class="search-icon"></i></button>
                                            </form>
                                        </div>
                                    </div>
                                    <div class="d-flex justify-content-between align-items-start">
                                        <div class="d-block d-lg-flex justify-content-between align-items-start">
                                            <b-button v-b-modal.modal-1 class="btn button-opaque" >{{ $t('SIZE MARKING') }} <i class="info-icon"></i></b-button>
                                            <img class="sizeRefImg" src="./../../public/images/img-tyre-size-referance.png" alt="">
                                        </div>
                                        <!-- <b-button v-b-modal.modal-1 class="btn button-opaque" >More Filters <i class="more-filer-icon"></i></b-button> -->
                                        <b-button @click="searchByTyreSize()" class="btn button-opaque" >{{ $t('More Filters') }} <i class="more-filer-icon"></i></b-button>
                                    </div>
                                    
                                </b-card-text>
                            </b-tab>
                            <b-tab class="bg-transparent" @click="changeVehicleType('Light Truck')" :active="'Light Truck' == activeVehicleTypes">
                              <template #title>
                                <div class="tab-icon light-truck-icon"></div>
                                <p class="m-0 font-weight-bold text-center">
                                  {{ $t('Van') }}
                                </p>
                              </template>
                                <b-card-text>
                                    <div class="cs-search-home">
                                        
                                        <div class="srch-form">
                                            <form class="form-inline">
                                                <div class="srch-title">
                                                    <p>{{ $t('Search by tyre size') }}</p>
                                                </div>
                                                <div class="">
                                                    <b-modal id="modal-1"    hide-footer hide-header >
                                                            <b-button class="closeicon" @click="$bvModal.hide('modal-1')"><i class="fas fa-times"></i></b-button>
                                                        <img v-show="currentLang == 'en_GB'" src="../../public/images/Renkaatalle-rengasvalinta_english.png" />
                                                        <img v-show="currentLang == 'fi_FI'" src="../../public/images/Renkaatalle-rengasvalinta_finnish.png" />
                                                    </b-modal>
                                                </div>
                                                <div class="form-items">
                                                    <label>{{ $t('Width') }}</label>
                                                    <b-form-select 
                                                        v-model="searchBySize.width"
                                                        value="255"
                                                        id="widths" 
                                                        name="widths"
                                                        @change="changeWidth($event)"
                                                        class="custom-select"
                                                        :options="widths"
                                                        value-field="width"
                                                        text-field="width">
                                                            <template v-slot:first>
                                                                <b-form-select-option :value="255" disabled></b-form-select-option>
                                                            </template>
                                                    </b-form-select>
                                                </div>
                                                <div class="form-items">
                                                    <label>{{ $t('Height') }}</label>
                                                    <b-form-select 
                                                        v-model="searchBySize.height"
                                                        id="height" 
                                                        name="height" 
                                                        @change="changeHeight($event)"
                                                        class="custom-select"
                                                        :options="heights"
                                                        value-field="aspect_ratio" 
                                                        text-field="aspect_ratio">
                                                            <template v-slot:first>
                                                                <b-form-select-option :value="null" disabled></b-form-select-option>
                                                            </template>
                                                    </b-form-select>
                                                </div>
                                                <div class="form-items">
                                                    <label>{{ $t('Wheel Diameter') }}</label>
                                                    <b-form-select 
                                                        v-model="searchBySize.diameter"
                                                        id="diameter" 
                                                        name="diameter" 
                                                        @change="changeDiameter($event)"
                                                        class="custom-select"
                                                        :options="diameters"
                                                        value-field="diameter"
                                                        text-field="diameter">
                                                            <template v-slot:first>
                                                                <b-form-select-option :value="null" disabled></b-form-select-option>
                                                            </template>
                                                    </b-form-select>
                                                </div>
                                                <div class="form-items">
                                                    <label>{{ $t('Season') }}</label>
                                                    <b-form-select 
                                                        v-model="searchBySize.tyreSeason"
                                                        id="tyreSeason" 
                                                        name="tyreSeason" 
                                                        @change="changeTyreSeason($event)"
                                                        class="custom-select"
                                                        value-field="name" 
                                                        text-field="name">
                                                            <!-- <template v-slot:first>
                                                                <b-form-select-option :value="null">{{ $t('All Seasons') }}</b-form-select-option>
                                                            </template> -->

                                                            <b-form-select-option  
                                                                v-for="allTyreSeason in allTyreSeasons" 
                                                                :value="allTyreSeason.name" 
                                                                :key="allTyreSeason.name" 
                                                                >{{ $t(allTyreSeason.name) }}</b-form-select-option>
                                                    </b-form-select>
                                                </div>
                                                <button type="button"  @click="searchByTyreSize()" :disabled="(searchBySize.width == null || searchBySize.height == null || searchBySize.diameter == null)" class="btn search-button">{{ $t('Search') }}<i class="search-icon"></i></button>
                                                
                                            </form>
                                        </div>
                                    </div>
                                    <div class="d-flex justify-content-between align-items-start">
                                        <div class="d-block d-lg-flex justify-content-between align-items-start">
                                            <b-button v-b-modal.modal-1 class="btn button-opaque" >{{ $t('SIZE MARKING') }} <i class="info-icon"></i></b-button>
                                            <img class="sizeRefImg" src="../../public/images/img-tyre-size-referance.png" alt="">
                                        </div>
                                        <!-- <b-button v-b-modal.modal-1 class="btn button-opaque" >More Filters <i class="more-filer-icon"></i></b-button> -->
                                        <b-button @click="searchByTyreSize()" class="btn button-opaque" >{{ $t('More Filters') }} <i class="more-filer-icon"></i></b-button>


                                        
                                    </div>
                                </b-card-text>
                            </b-tab>
                            <b-tab  :active="'Service Points' == activeVehicleTypes" @click="selectedSearchedTab = 'Service Points' " :class="['pb-3']">
                            <template #title>
                              <div class="tab-icon service-point-icon"></div>
                              <p class="m-0 font-weight-bold text-center">
                                {{ $t('Service Points') }}
                              </p>
                            </template>
                            <b-card-text>
                              <div class="cs-search-home container search-by-service-point-container set-sticky pb-3">
                                <div class="w-100 py-3 pb-lg-0">
                                  <!-- align-items-normal -->
                                  <form class="form-inline  sp-search-form" @submit.prevent="() => {return false;}">
                                    <div class="form-group srch-title sp-title sp-margin-right-lg-2 sp-mr-767" :class="{'sp-title-finish' : (currentLang === 'fi_FI')}">
                                      <p class=""> {{ $t('Find a service point') }} </p>
                                    </div>
                                    <div class="sp-group-item-767">
                                      <div class="form-group sp-form-item sp-margin-top-mdsm-2 sp-w-50">
                                        <label for="sp_vehicle_type">{{ $t("Select vehicle type") }}</label>
                                        <b-form-select
                                            id="sp_vehicle_type"
                                            class=""
                                            :options="currentLang === 'fi_FI' ? vehicle_types_fi : vehicle_types"
                                            v-model="default_v_t"
                                            @change="searchServicePoints()"
                                        ></b-form-select>
                                      </div>
                                      <div class="form-group d-max-767 sp-form-item sp-margin-top-mdsm-2 sp-w-50">
                                        <label for="sp_maximum_distance">{{ $t("Distance") }}</label>
                                        <b-form-select
                                            id="sp_maximum_distance"
                                            class=""
                                            :options="currentLang === 'fi_FI' ? kilometerRange_fi : kilometerRange"
                                            v-model="defaultKilometer"
                                            @change="searchServicePoints()"
                                        ></b-form-select>
                                      </div>
                                    </div>
                                    <div class="form-group sp-form-item sp-input-group flex-grow-1 mr-2 sp-margin-top-mdsm-2">
                                      <label>{{ $t("Type your city or post code") }}</label>
                                      <vue-google-autocomplete
                                          id="map"
                                          classname="form-control w-100 google-input-box sp-search-input-append"
                                          :class="addressError"
                                          :placeholder="$t('Type your city or post code')"
                                          v-on:placechanged="getAddressData"
                                          :country="['fi']"
                                          v-model="address"
                                          required="true"
                                          types="geocode"
                                          ref="autocomplete"
                                          @keyup="clearSearchedServicePoint($event)"
                                      >
                                      </vue-google-autocomplete>
                                      <button type="button" @click="searchServicePoints()" class="btn search-button sp-search-btn-append">
                                        <i class="search-icon"></i>
                                      </button>
                                    </div>
                                    <div class="form-group sp-form-item mr-2 sp-margin-top-mdsm-2 d-none-767">
                                      <label for="sp_maximum_distance">{{ $t("Distance") }}</label>
                                      <b-form-select
                                          id="sp_maximum_distance"
                                          class=""
                                          :options="currentLang === 'fi_FI' ? kilometerRange_fi : kilometerRange"
                                          v-model="defaultKilometer"
                                          @change="searchServicePoints()"
                                      ></b-form-select>
                                    </div>
                                    <div class="form-group sp-form-item sp-margin-right-lg-2 sp-margin-top-mdsm-2 d-max-425 sp-mr-425 d-min-992">
                                      <button type="button" class="btn search-button sp-w-100-425 sp-br-remove-425" @click="searchServicePoints()">
                                                <span class="search-button-title">
                                                  {{ $t('Show service points') }}
                                                </span>
                                        <i class="search-icon"></i>
                                      </button>
                                    </div>
                                  </form>
                                  <div class="hm-single-dealer-container d-flex align-items-start justify-content-between pb-lg-0 p-sm-0 border-bottom flex-wrap flex-sm-wrap" v-if="service_points.length > 0">
                                    <div class="service-point-column font-weight-bold sp-mt-425">
                                              <span class="float-right cursor-pointer" id="popover-target-sorting-content">
                                                <span class="font-12">
                                                  {{ getSortingTitle }}
                                                  <i v-if="defaultSort === 0" class="fa fa-sort-numeric-asc" aria-hidden="true"></i>
                                                  <i v-if="defaultSort === 1" class="fa fa-sort-numeric-desc" aria-hidden="true"></i>
                                                  <i v-if="defaultSort === 2" class="fa fa-sort-alpha-asc" aria-hidden="true"></i>
                                                  <i v-if="defaultSort === 3" class="fa fa-sort-alpha-desc" aria-hidden="true"></i>
                                                </span>
                                              </span>
                                      <p class="font-16 mt-2 mb-0 font-weight-light">
                                        {{ ($t('service_point_title_tagline')).replace('{kilometer}', defaultKilometer).replace('{city}', address).replace('{service_point_count}', (service_points.length || 0)) }}
                                      </p>
                                      <b-popover target="popover-target-sorting-content" triggers="hover" placement="bottom">
                                        <b-form-select :options="currentLang === 'fi_FI' ? sortingOptions_fi :  sortingOptions" v-model="defaultSort" @change="sortSearchedServicePoints()"></b-form-select>
                                      </b-popover>
                                    </div>
                                    <div class="service-column font-weight-bold px-3 d-none-767">
                                      <p class="font-16 mt-2 font-weight-light">{{ $t('Installation price per tyre') }} </p>
                                    </div>
                                    <div class="next-available-time-column font-weight-bold px-3 d-min-992">
                                      <p class="font-16 mt-2 mb-0 font-weight-light" id="thisthis">{{ $t("Next available time") }}</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="loading" v-if="sbspLoader"></div>
                              <div class="search-by-service-point-container" v-if="showServices && service_points.length && !sbspLoader">
                                <div class="w-100" v-if="showServices && service_points.length && !sbspLoader">
                                  <div v-for="(service_point, service_point_index) in service_points" :key="service_point_index"
                                       class="hm-single-dealer-container border mb-3"
                                       :class="{'active' : (selectedServicePoint != null && service_point.id == selectedServicePoint.id), 'mt-lg-3 mt-md-3 mt-sm-2' : service_point_index === 0}"
                                  >
                                    <div class="d-flex align-items-start justify-content-between px-3 pt-3 pb-lg-3 flex-wrap flex-sm-wrap">
                                      <div class="service-point-column">
                                        <ul class="service-point-details font-14-991">
                                          <li class="online-icon d-max-767" v-if="service_point.time_slots.length">{{ $t('Online appointment available') }} </li>
                                          <li class="phone-icon d-max-767" v-else>
                                            {{ $t('Appointment by phone') }} :
                                            <p class="pl-1">{{ $t('tel')}}. {{service_point.contact_number}}</p>
                                          </li>
                                          <li class="organization-name">
                                            {{ service_point.company_name }}
                                            <span class="float-right cursor-pointer mr-2" :id="`service_point_info_${service_point.id}`"><i class="info-icon"></i></span>
                                            <popover-service-point-right :service_point="service_point"></popover-service-point-right>
                                          </li>
                                          <li class="distance-icon d-flex align-items-center">
                                            <span class="font-italic km-container">{{ parseFloat(service_point.distance_km).toFixed(2) }} {{ $t('km') }}</span>
                                            <div class="sp-logo-container" v-if="service_point.profile_image_path !== null">
                                              <img :src="`${service_point.image_base_path}${service_point.profile_image_path}`" class="sp-logo">
                                            </div>
                                          </li>
                                          <li class="address-icon">{{ service_point.address_line_1 }} {{ service_point.address_line_2 !== 'null' ? service_point.address_line_2  : '' }}</li>
                                          <li class="opening-hour-icons" v-if="Object.entries(service_point.time_slots).length" :id="`opening_hour_${service_point.id}`">
                                            {{ $t('Opening hours') }}
                                            <HomepageOpeningHourPopover :service_point="service_point"/>
                                          </li>
                                          <li class="address-last">
                                            {{ !((service_point.address_line_1).toLowerCase().includes(service_point.zipcode.toLowerCase()) && service_point.address_line_1 !== null && service_point.address_line_1.toLowerCase().includes(service_point.zipcode.toLowerCase())) ? (service_point.zipcode + ',') : ''}}
                                            {{ !(service_point.address_line_1.toLowerCase().includes(service_point.city.toLowerCase()) && service_point.address_line_1 !== null && service_point.address_line_1.toLowerCase().includes(service_point.city.toLowerCase())) ? service_point.city : ''}}
                                          </li>
                                          <li class="time-icon d-max-991" v-if="service_point.time_slots.length">
<!--                                            {{ nextAvailableSlotDateCommon(service_point) }}-->
                                            <span class="cursor-pointer" v-b-modal="'my-modal-'+service_point.dealer_id" @click="showModal = true"><i class="info-icon" :id="'nat_responsive-'+service_point.dealer_id"></i></span>
                                            <b-popover :target="'nat_responsive-'+service_point.dealer_id" triggers="hover" placement="top" :custom-class="'custom-popover-nat-info'">
                                              {{ $t("Click here to show the available timeslots") }}
                                            </b-popover>
                                          </li>
                                        </ul>
                                        <div class="d-max-767 d-service-block-max-767">
                                          <HomeViewAttachedService :service_point="service_point" id_prefix="d_max_767" :display_service_limit="2"></HomeViewAttachedService>
                                        </div>
                                      </div>
                                      <div class="service-column px-3 d-none-767">
                                        <HomeViewAttachedService :service_point="service_point" id_prefix="d_min_767" :display_service_limit="3"></HomeViewAttachedService>
                                        <ul class="service-point-details font-14-991" v-if="service_point.time_slots.length">
                                          <li class="online-icon d-max-991">{{ $t('Online appointment available') }} </li>
                                        </ul>
                                      </div>
                                      <div class="next-available-time-column px-3 d-min-992">
                                        <ul class="service-point-details">
                                          <li class="time-icon" v-if="service_point.time_slots.length">
                                            {{ nextAvailableSlotDateCommon(service_point) }}
                                            <span class="cursor-pointer" v-b-modal="'my-modal-'+service_point.dealer_id" @click="showModal = true"><i class="info-icon" :id="'nat-'+service_point.dealer_id"></i></span>
                                            <b-popover :target="'nat-'+service_point.dealer_id" triggers="hover" placement="top" :custom-class="'custom-popover-nat-info'">
                                              {{ $t("Click here to show the available timeslots") }}
                                            </b-popover>
                                          </li>
                                          <li class="online-icon" v-if="service_point.time_slots.length">{{ $t('Online appointment available') }} </li>
                                          <li class="phone-icon" v-else>
                                            {{ $t('Appointment by phone') }} :
                                            <p class="pl-1">{{ $t('tel')}}. {{service_point.contact_number}}</p>
                                          </li>
                                        </ul>
                                        <div class="pt-2" v-if="!1"><button class="text-uppercase pt-2 pb-2 pl-3 rounded pr-3 bg-dark color-white call-appointment-btn" ><i class="fa fa-phone"></i> {{ $t("Appointment") }}</button></div>
                                        <div class="pt-2"><button @click="selectAndRemoveServicePoint(service_point);searchByTyreSize('yes')" class="text-uppercase bg-success pt-2 pb-2 pl-3 rounded pr-3 color-white appointment-btn" ><i class="fa fa-search"></i> {{ $t("Search Tyres") }}</button></div>
                                      </div>
                                    </div>

                                    <div class="d-max-991">
                                      <div class="d-flex align-content-center justify-content-end appointment-search-btn-container py-2">
                                        <div v-if="!1" class="w-50-appointment-btn">
                                          <button class="text-uppercase pt-2 pb-2 pl-3 rounded pr-3 btn-block bg-dark color-white call-appointment-btn" ><i class="fa fa-phone"></i> {{ $t("Appointment") }}</button>
                                        </div>
                                        <div class="w-50-search-btn">
                                          <button @click="selectAndRemoveServicePoint(service_point);searchByTyreSize('yes')" class="text-uppercase bg-success btn-sm-block pt-2 pb-2 pl-3 rounded pr-3 color-white appointment-btn btn-block" ><i class="fa fa-search"></i> {{ $t("Search Tyres") }}</button>
                                        </div>
                                      </div>
                                    </div>
                                    <b-modal class="modal" :hide-footer="true" title-tag='h4' header-text-variant='dark' title-class="text-uppercase" name="modal" v-if="showModal" :id="'my-modal-'+service_point.dealer_id">
                                      <template #modal-header="{ close }">
                                        <div>
                                          <h4 class="text-uppercase">{{ $t('Available time') }}</h4>
                                          <p class="mb-0">{{ $t("available_time_tagline") }}</p>
                                        </div>
                                        <button type="button" aria-label="Close" class="close text-dark" @click="close()">×</button>
                                      </template>
                                      <div v-if="service_point">
                                        <appointment-popup @goToError="goToError" @hidepopup="removeAppointmentPopup" :allowedTimes="[]" :dealerService="service_point" :availableDays="availableSlotDayCommon(service_point)" :localDealersList="service_points" :showProceedButton="false"></appointment-popup>
                                      </div>
                                    </b-modal>
                                  </div>
                                </div>
                              </div>
                              <div class="mt-3" v-if="showServices && service_points.length == 0 && !sbspLoader">
                                <p class="text-danger">{{ $t("It seems there is no service point available for the selected location. Kindly contact us on Chat or customer service 0405529803 for further assistance.") }}</p>
                              </div>

                            </b-card-text>
                          </b-tab>
                        </b-tabs>
                    </b-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { BFormSelect } from 'bootstrap-vue'
import VueGoogleAutocomplete from 'vue-google-autocomplete'
import HomeViewAttachedService from "../components/HomeViewAttachedService";
import HomepageOpeningHourPopover from "../components/HomepageOpeningHourPopover";
import PopoverServicePointRight from "../components/PopoverServicePointRight";
import AppointmentPopup from "../components/AppointmentPopup";

export default {
    name: "search-tabs",
    props: ['name', 'image_path', 'type', 'tyre_size_width', 'tyre_size_height', 'tyre_size_diameter', 'brand_name'],
    components: {
      'HomepageOpeningHourPopover' : HomepageOpeningHourPopover,
      'vue-google-autocomplete': VueGoogleAutocomplete,
      'HomeViewAttachedService' : HomeViewAttachedService,
      'appointment-popup': AppointmentPopup,
      'popover-service-point-right' : PopoverServicePointRight
    },
    component: {
        'b-form-select': BFormSelect,
    },
    data() {
        return {
            baseUrl: process.env.WEBSHOP_URL,
            licencePlateSearch: {
                vehicleType: 'Car',
                licencePlate: ''
            },
            searchBySize: {
                width: null,
                height: null,
                diameter: null,
                tyreSeason: null,
                loadIndex: null,
                speedIndex: null,

            },
            isHome: true,
            isSearch: false,
            bannerList: [],
            bannerLoading: true,
            image_loaded : true,
            addressError: '',
            selectedSearchedTab : '',
            showModal : false,
        }
    },
    mounted() {
      this.setAddressManually()
    },
    computed: {
        ...mapGetters('app', ['currentLang']),
        ...mapGetters('search', [
            'vehicleTypes',
            'widths',
            'heights',
            'diameters',
            'allSpeedIndexes',
            'allLoadIndexes',
            'allTyreSeasons',
            'activeVehicleTypes',
            'activeWidth',
            'activeHeight',
            'activeDiameter',
            'activeSpeedIndex',
            'activeLoadIndex',
            'activeTyreSeason',
            'activeLicencePlate',
            'loading']
        ),
      ...mapGetters('appointments', ['holidays']),
      ...mapGetters("menu", ["menusList"]),
      ...mapGetters("search_dealer", ['service_points', 'selectedServicePoint', 'tyre_category']),
      ...mapGetters('search_by_service_point', ['sbspLoader', 'showServices', 'defaultSort', 'address', 'defaultKilometer', 'default_v_t', 'kilometerRange', 'kilometerRange_fi', 'vehicle_types', 'vehicle_types_fi', 'sortingTitles', 'sortingTitles_fi', 'sortingOptions', 'sortingOptions_fi']),
      defaultKilometer : {
        get() { return this.$store.getters["search_by_service_point/defaultKilometer"]},
        set(value) {this.$store.dispatch("search_by_service_point/setDefaultKilometer", value)}
      },
      default_v_t : {
        get() {return this.$store.getters["search_by_service_point/default_v_t"]},
        set(value) {this.$store.dispatch("search_by_service_point/setDefaultVT", value)}
      },
      defaultSort : {
        get() {return this.$store.getters["search_by_service_point/defaultSort"]},
        set(value) {this.$store.dispatch("search_by_service_point/setDefaultSort", value)}
      },
      address : {
        get() {return this.$store.getters["search_by_service_point/address"]},
        set(value) {this.$store.dispatch("search_by_service_point/setAddress", value)}
      },
      getSortingTitle() {
        return this.currentLang == "fi_FI" ? this.sortingTitles_fi[this.defaultSort] : this.sortingTitles[this.defaultSort]
      }
    },
    created() {
        if ("Default_V_T" in localStorage) {
          this.setDefaultVT(localStorage.getItem("Default_V_T"))
        }
        if ("DefaultKilometer" in localStorage) {
          this.setDefaultKilometer(localStorage.getItem("DefaultKilometer"))
        }
        this.fetchVehicleTypes()
        this.storeTyreSeasons();

      this.getHolidayList();
      if ("GoogleAddress" in localStorage) {
        this.searchServicePoints();
      }
    },
    watch: {
      '$route' () {
        this.setDefaultServicePoint()
      },
      service_points: {
        handler() {
          this.setDefaultServicePoint()
        }
      },
        'activeVehicleTypes': {
            handler(newValue) {
              this.licencePlateSearch.vehicleType = (newValue === 'All' ? 'Car' : newValue);
              this.fetchWidths({});

              if (this.licencePlateSearch.vehicleType == 'Car') {
                this.changeWidth(this.carSelectedWidth)
                this.fetchHeights({ "width": this.searchBySize.width});
                this.changeHeight(this.carSelectedAspectRatio)
                this.fetchDiameters({ "searchBySize": this.searchBySize});
                this.changeDiameter(this.carSelectedDiameter)
                this.searchBySize.tyreSeason = this.carSelectedSeason
              } else if (this.licencePlateSearch.vehicleType == 'Light Truck')  {
                this.changeWidth(this.vanSelectedWidth)
                this.fetchHeights({ "width": this.searchBySize.width});
                this.changeHeight(this.vanSelectedAspectRatio)
                this.fetchDiameters({ "searchBySize": this.searchBySize});
                this.changeDiameter(this.vanSelectedDiameter)
                this.searchBySize.tyreSeason = this.vanSelectedSeason
              }
              this.changeVehicleType(newValue)
            },
            immediate: true
        },
        'activeWidth': {
            handler(newValue) {
                this.searchBySize.width = newValue;
            },
            immediate: true
        },
        'activeHeight': {
            handler(newValue) {
                this.searchBySize.height = newValue;
            },
            immediate: true
        },
        'activeDiameter': {
            handler(newValue) {
                this.searchBySize.diameter = newValue;
            },
            immediate: true
        },
        'activeSpeedIndex': {
            handler(newValue) {
                this.searchBySize.speedIndex = newValue;
            },
            immediate: true
        },
        'activeLoadIndex': {
            handler(newValue) {
                this.searchBySize.loadIndex = newValue;
            },
            immediate: true
        },
        'activeTyreSeason': {
            handler(newValue) {
                this.searchBySize.tyreSeason = newValue;
            },
            immediate: true
        },
        'activeLicencePlate': {
            handler(newValue) {
                this.licencePlateSearch.licencePlate = newValue;
            },
            immediate: true
        },
        'searchBySize.width': {
            handler() {
                this.fetchHeights({ "width": this.searchBySize.width });
            },
            immediate: true
        },
        'searchBySize.height': {
            handler() {
                this.fetchDiameters({ "searchBySize": this.searchBySize });
            },
            immediate: true
        },
        'searchBySize.diameter': {
            handler() {
                let season = process.env.VUE_APP_DEFAULT_SEASON
                if (this.licencePlateSearch.vehicleType === 'Car') {
                  season = this.carSelectedSeason
                }
                if (this.licencePlateSearch.vehicleType === 'Light Truck') {
                  season = this.vanSelectedSeason
                }
                this.searchBySize.tyreSeason = season;
            },
            immediate: true
        },
        'tyre_size_width': {
            handler(newValue) {
                this.searchBySize.width = newValue;
            }
        },
        'tyre_size_height': {
            handler(newValue) {
                this.searchBySize.height = newValue;
            }
        },
        'tyre_size_diameter': {
            handler(newValue) {
                this.searchBySize.diameter = newValue;
            }
        },
        'allTyreSeasons': {
            handler() {
                var allExist = this.allTyreSeasons.find(({ id }) => id === "All");
                if (allExist == undefined) {
                    this.allTyreSeasons.unshift({"id": "All", "name": "All"});
                }
            }
        },
        'type' : {
          handler() {
            this.searchAndSetBannerText();
          },
          immediate: true
        },
        'name' : {
          handler() {
            this.searchAndSetBannerText();
          },
          immediate: true
        },
        'menusList' : {
          handler() {
            this.searchAndSetBannerText();
          },
          immediate: true
        },
      'currentLang': {
        handler() {
          this.setDealers([]);
          this.searchServicePoints();
        }
      },
      'defaultKilometer' : {
        handler(newKilometer) {
          localStorage.setItem("DefaultKilometer",newKilometer)
        }
      },
      'default_v_t' : {
        handler(newVehicleType) {
          localStorage.setItem("Default_V_T",newVehicleType)
        }
      }
    },
    methods: {
        ...mapActions("search", [
            "filterProducts",
            "getFilters",
            "fetchWidths",
            "fetchHeights",
            "fetchDiameters",
            "changeCarTypes",
            "changeWidthStore",
            "changeHeightStore",
            "changeDiameterStore",
            "changeSpeedIndexStore",
            "changeLoadIndexStore",
            "changeTyreSeasonStore",
            "changeLicencePlateStore",
            "fetchVehicleTypes",
            "fetchAllSpeedIndexes",
            "fetchAllTyreSeasons",
            "fetchAllLoadIndexes",
            "storeTyreSeasons"]),
        ...mapActions('appointments', ['getHolidayList']),
      ...mapActions("search_dealer", ["fetchDealers", 'setStrAddressWS', 'setSearchedZipcode', 'setDealers', 'setSelectedServicePoint', 'getTyreCategoryByVehicleType']),
        ...mapActions('search_by_service_point', ['setShowServices', 'searchServicePoints', 'sortSearchedServicePoints', 'setDefaultKilometer', 'setDefaultVT', 'setDefaultServicePoint', 'removeOlderAppointment']),
        changeWidth(seletedWidth) {
            this.changeWidthStore(seletedWidth);
        },
        changeHeight(seletedHeight) {

            this.changeHeightStore(seletedHeight);
        },
        changeDiameter(seletedDiameter) {
            this.changeDiameterStore(seletedDiameter);
        },
        changeInch(seletedInch) {
            this.changeInchterStore(seletedInch);
        },
        changeSpeedIndexes(seletedSpeedIndexes) {
            this.changeSpeedIndexStore(seletedSpeedIndexes);
        },
        changeLoadIndexes(seletedLoadIndexes) {
            this.changeLoadIndexStore(seletedLoadIndexes);
        },
        changeTyreSeason(seletedTyreSeason) {
            this.changeTyreSeasonStore(seletedTyreSeason);
        },
        changeVehicleType(cartypeData) {
            // this.carType = cartypeData;
            this.changeCarTypes(cartypeData);

            if(cartypeData === 'Car') {
              this.searchBySize.width = this.carSelectedWidth
              this.searchBySize.height = this.carSelectedAspectRatio
              this.searchBySize.diameter = this.carSelectedDiameter
              this.searchBySize.tyreSeason = this.carSelectedSeason
            } else if(cartypeData === 'Light Truck') {
              this.searchBySize.width = this.vanSelectedWidth
              this.searchBySize.height = this.vanSelectedAspectRatio
              this.searchBySize.diameter = this.vanSelectedDiameter
              this.searchBySize.tyreSeason = this.vanSelectedSeason
            } else {
              this.searchBySize.width = null ;
              this.searchBySize.height = null;
              this.searchBySize.diameter = null;
              this.searchBySize.tyreSeason = null;
            }
            this.searchBySize.speedIndex = null;
        },
        async searchByTyreSize() {

            let selectTyreSeasons = [];
            if (this.searchBySize.tyreSeason == "All") {
                if(this.allTyreSeasons.length != 0 ){
                    this.allTyreSeasons.filter((el) => {
                        if(el.name != "All") {
                            selectTyreSeasons.push(el.name);
                        }
                    });
                }
            } else if(this.searchBySize.tyreSeason != null) {
                selectTyreSeasons.push(this.searchBySize.tyreSeason)
            }

            let params = {
                width: this.searchBySize.width,
                height: this.searchBySize.height,
                diameter: this.searchBySize.diameter,
                // tyre_season: this.searchBySize.tyreSeason,
                tyre_season: selectTyreSeasons,
                speed_index: this.searchBySize.speedIndex,
                load_index: this.searchBySize.loadIndex,
            };

            if (this.licencePlateSearch.vehicleType === 'Car') {
              localStorage.setItem('car_selected_width', this.searchBySize.width)
              localStorage.setItem('car_selected_aspect_ratio', this.searchBySize.height)
              localStorage.setItem('car_selected_diameter', this.searchBySize.diameter)
              localStorage.setItem('car_selected_season', this.searchBySize.tyreSeason)
            }
            if (this.licencePlateSearch.vehicleType === 'Light Truck') {
              localStorage.setItem('van_selected_width', this.searchBySize.width)
              localStorage.setItem('van_selected_aspect_ratio', this.searchBySize.height)
              localStorage.setItem('van_selected_diameter', this.searchBySize.diameter)
              localStorage.setItem('van_selected_season', this.searchBySize.tyreSeason)
            }
            
            if (this.type == 'brand') {
                params.brand = this.name
            }
            // if (this.type == 'model') {
            //     params.model = this.name
            // }
            /*this.$router.push({
                name: 'search-by-tyre-size',
                params: { vehicletype: vehicleTypeStr },
                query: params,
                replace: true
            });*/
            await this.getTyreCategoryByVehicleType(this.licencePlateSearch.vehicleType)
            var route_param_vt = this.currentLang === 'en_GB' ? this.tyre_category.slug_en : this.tyre_category.slug_fi
            this.$router.push(this.go_to_products(route_param_vt, params,true));
        },
        searchByLicencePlate() {

            this.$router.push({
                name: 'search-by-tyre-size',
                params: { vehicletype: this.licencePlateSearch.vehicleType },
                query: {
                    licenceplate: this.licencePlateSearch.licencePlate
                },
                replace: true
            });
        },
      searchAndSetBannerText() {
          let banner_text = '';
          try {
            if (this.type != '' && this.name != '' && this.menusList.length > 0) {
              if ('season' === this.type) {
                const menu = this.menusList.find(item => item.type == this.type)
                if (menu !== undefined) {
                  const CHILDObject = menu.children.find(ch => ch.tyre_season.name == this.name)
                  if (CHILDObject !== undefined) {
                    banner_text = ('en_GB' === this.currentLang) ? CHILDObject['banner_text_en'] : CHILDObject['banner_text_fi'];
                  }
                }
              } else if('tyre_category' === this.type) {
                const menu = this.menusList.find(item => item.type == 'vehicle')
                if (menu !== undefined) {
                  const CHILDObject = menu.children.find(ch => ch.tyre_category[0].name == this.name)
                  if (CHILDObject !== undefined) {
                    banner_text = ('en_GB' === this.currentLang) ? CHILDObject['banner_text_en'] : CHILDObject['banner_text_fi'];
                  }
                }
              } else if('brand' === this.type) {
                const menu = this.menusList.find(item => item.type == 'brand')
                if (menu !== undefined) {
                  const CHILDObject = menu.children.find(ch => ch.brand[0].name == this.name)
                  if (CHILDObject !== undefined) {
                    banner_text = ('en_GB' === this.currentLang) ? CHILDObject['banner_text_en'] : CHILDObject['banner_text_fi'];
                  }
                }
              } else if ('tyre_size' === this.type) {
                const menu = this.menusList.find(item => item.type == 'size')
                if (menu !== undefined) {
                  const CHILDObject = menu.children.find(ch => ch.name_en == this.name)
                  if (CHILDObject !== undefined) {
                    banner_text = ('en_GB' === this.currentLang) ? CHILDObject['banner_text_en'] : CHILDObject['banner_text_fi'];
                  }
                }
              } else if('model' === this.type) {
                const menu = this.menusList.find(item => item.type == 'brand')
                if (menu !== undefined) {
                  const ChildBrandObject = menu.children.find(ch => ch.brand[0].name == this.brand_name)
                  if (ChildBrandObject !== undefined) {
                    const CHILDObject = ChildBrandObject.children.find(ch => ch.name_en == this.name)
                    if (CHILDObject != undefined) {
                      banner_text = ('en_GB' === this.currentLang) ? CHILDObject['banner_text_en'] : CHILDObject['banner_text_fi'];
                    }
                  }
                }
              }
            }
          } catch (e) {
            banner_text = '';
          }
          return banner_text;
      },
      getBackgroundStyle() {
        return {
          'background-image': `url('${this.image_path}')`
        }
      },
      getWindowWidth() {
        this.windowInnerWidth = window.innerWidth;
      },
      setDefaultHeight() {
        console.log("Image Loaded : Image Not Found!");
        this.image_loaded = false;
      },
      getAddressData(place, placeResultData) {
        localStorage.setItem('GoogleAddress', JSON.stringify(place))
        localStorage.setItem('GoogleSelectedPlace', JSON.stringify(placeResultData))
        this.address = placeResultData.formatted_address;
      },
      async selectAndRemoveServicePoint(ServicePoint) {
        this.setSelectedServicePoint(ServicePoint)
        localStorage.setItem("SearchedSelectedServicePoint", JSON.stringify(ServicePoint))
      },
      setAddressManually() {
        if ("GoogleSelectedPlace" in localStorage) {
          const placeResultData = JSON.parse(localStorage.getItem("GoogleSelectedPlace"))
          this.address = placeResultData.formatted_address;
          this.searchServicePoints();
        }
      },
      clearSearchedServicePoint() {
        if(this.$refs.autocomplete.$el.value === '') {
          localStorage.removeItem("SearchedSelectedServicePoint")
          localStorage.removeItem('GoogleAddress')
          localStorage.removeItem('GoogleSelectedPlace')
          localStorage.removeItem('DefaultKilometer')
          localStorage.removeItem('Default_V_T')
          this.defaultKilometer = 20
          this.default_v_t = 1
          this.setSelectedServicePoint(null)
          this.setShowServices(false)
          this.address = ''
          this.setDealers([]);
        }
      },
      removeAppointmentPopup() {
        this.showModal = false
      }
    }
};
</script>
<style scoped>
/* .cp-main #home { position: relative; top: 74px; } */
.category-banner .category-banner-inner { height: auto; background-size: cover; background-position: center; }
.category-slider-show {
  position: relative;
  margin-top: 82px !important;
  background-position: center center;
  background-repeat: no-repeat;
}
.category-slider-show .banner-area { position: absolute !important; top: 0; width: 100%; height: 100%; }
.category-slider-show .category-banner-inner { padding: 0px; margin: 0px; max-width: 100%; height: auto; position: relative;}
.category-slider-show .category-banner-inner img { width: 100%; height: auto;}

/*.banner-area .margin-top-66 {
    margin-top: 132px;
}*/
@media only screen and (min-width: 1198px) {
  .category-banner-inner.min-height-with-banner {
    min-height: 600px;
  }
}
@media only screen and (min-width: 994px) and (max-width: 1197px) {
  .category-banner-inner.min-height-with-banner {
    min-height: 450px;
  }
}
@media only screen and (min-width: 769px) and (max-width: 993px) {
  .category-banner-inner.min-height-with-banner {
    min-height: 400px;
  }
}

@media only screen and (min-width: 992px) and (max-width: 1198px) {
  .search-tyre .srch-form .custom-select {
    height: 40px;
    padding: 8px 25px 8px 10px !important;
    margin-bottom: 0 !important;
    width: auto;
  }
  .search-tyre .srch-form .search-button {
    padding: 8px !important;
    height: 40px !important;
    width: auto;
  }
  .cs-search-home .srch-title {
    padding: 8px 25px 8px 10px;
    margin-bottom: 10px;
  }
  .banner-area { padding: 60px 0px 60px 0px; }
  .banner-area h1 span {
    display: block;
    margin-bottom: auto;
    font-size: 20px;
    font-weight: 400;
    padding-left: 15px;
  }
  .banner-area {
    padding: 25px 0px;
  }
  .category-slider-show .category-banner-inner img {height: 100% !important;}
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
  .search-tyre .srch-form .custom-select {
    height: 40px;
    padding: 8px 25px 8px 10px !important;
    margin-bottom: 0 !important;
    width: auto;
  }
  .search-tyre .srch-form .search-button {
    padding: 8px !important;
    height: 40px !important;
    width: auto;
  }
  .cs-search-home .srch-title {
    padding: 8px 25px 8px 10px;
    margin-bottom: 10px;
  }
  .banner-area { padding: 60px 0px 60px 0px; }
  .banner-area h1 span {
    display: block;
    margin-bottom: auto;
    font-size: 20px;
    font-weight: 400;
    padding-left: 15px;
  }
  .banner-area {
    padding: 25px 0px;
  }
  .category-slider-show .category-banner-inner img {height: 100% !important;}
}

@media only screen and (max-width: 768px) {
  .category-slider-show .banner-area { position: unset !important; }
}

@media only screen and (max-width: 576px) {
    .banner-area { padding: 40px 0px 0px 0px; }
    .category-slider-show { position: relative; }
    .category-slider-show .category-banner-inner img { margin-top: 29px; height: 100%;}
    .banner-area .margin-top-66 {
      margin-top: 0px;
    }
   .search-tyre .srch-form .custom-select {
     height: 40px;
     padding: 8px 25px 8px 10px;
   }
  .search-tyre .srch-form .search-button {
    padding: 8px;
    height: 40px;
  }
}

@media only screen and (min-width: 577px) and (max-width: 768px) {
  .category-slider-show .category-banner-inner img {
    height: auto;
  }
  .form-items {
    width: 50%;
    padding: 8px 5px;
  }
  .cs-search-home .srch-title {
    padding: 8px 5px;
  }
  .search-tyre .srch-form .custom-select {
    width: 100%;
    height: 40px;
    padding: 8px 25px 8px 10px !important;
    margin-bottom: 0 !important;
  }
  .search-tyre .srch-form .search-button {
    padding: 8px !important;
    height: 40px !important;
    width: 100%;
    border-radius: 0px;
  }
  .banner-area {
      padding: 1.5rem 0;
  }
}

/*Search By Service Point Css*/
.align-items-normal {
  align-items: normal !important;
}

.search-by-service-point-btn {
  border: 1px solid #1b9b38 !important;
  background: #28a745;
  color: #fff;
  border-radius: 0 20px 20px 0;
}
.search-by-service-point-btn i {
  padding-left: 20px;
}
.sp-input-group .sp-search-btn-append {display: none !important;}

@media (min-width: 281px) {
  .cs-search-home .srch-title.sp-title.sp-title-finish {
    min-width: 170px !important;
  }
}
@media (max-width: 280px) {
  .cs-search-home .srch-title.sp-title {
    min-width: 170px !important;
  }
}
@media (min-width: 768px) and (max-width: 991px){
  .sp-search-form .sp-form-item {
    display: block !important;
    font-size: 13px;
    margin-bottom: 1rem;
    width: auto !important;
  }

  .sp-search-form .search-button-title{display: none;}
  .sp-search-form .search-button {
    display: ruby;
    border-radius: 0 !important;
  }
  .form-group.sp-form-item.d-max-767 {
    display: none !important;
  }
  .cs-search-home .srch-title.sp-title {
    border-radius: 0;
    border: none;
    border-bottom: 1px solid #da9d26 !important;
    margin-bottom: 1rem;
    text-transform: uppercase;
    text-align: center;
    padding: 12px;
  }
}

@media (min-width: 426px) and (max-width: 767px){
  .sp-search-form .search-button-title{display: none;}
  .sp-search-form .search-button,
  .sp-input-group .sp-search-btn-append{
    display: ruby !important;
    width: 20% !important;
    border-radius: 0 !important;
  }
  .google-input-box.sp-search-input-append {
    width: 80% !important;
  }
  .sp-search-form .sp-search-btn-append .search-icon {margin-left: 0 !important;}

  .sp-search-form .sp-form-item.sp-input-group {
    position: relative;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-box-align: stretch;
    -ms-flex-align: stretch;
    align-items: stretch;
    width: 100%;
  }
}

@media (max-width: 767px){
  .cs-search-home.search-by-service-point-container .form-inline {
    flex-direction: column;
    align-items: stretch;
  }

  .cs-search-home .srch-title.sp-title {
    border-radius: 0;
    border: none;
    border-bottom: 1px solid #da9d26 !important;
    margin-bottom: 1rem;
    text-transform: uppercase;
    text-align: center;
    padding: 12px;
  }
  .search-by-service-point-btn {
    margin-top: 1rem;
    width: 100%;
    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;
  }

  .sp-search-form .sp-form-item {
    margin-bottom: 1rem;
    width: 100%;
  }
}

@media (max-width: 1200px) {
  .cs-search-home.search-by-service-point-container .srch-title {
    padding: 7px 20px 5px !important;
  }
}

</style>
